export default __webpack_public_path__ + "static/media/shape10.406dc24a.png";